<template>
    <el-drawer custom-class="Order-Detail-Drawer"
        @close="$emit('close')"
        :visible.sync="drawer"
        size="100%"
        direction="btt">
        <div style="padding: 20px;position: relative">
            <div style="padding: 10px;position: sticky;top: 0;right: 0;z-index: 99;text-align: right">
                 <el-button @click="drawer = false"  type="primary">返回行程轴</el-button>
            </div>
            <order-detail :isShowTopBtn="false" :datas="datas"></order-detail>
        </div>
    </el-drawer>
</template>
<script>
    import OrderDetail from "@/views/mechanism/components/myDealChild/child/orderDetail.vue";
    export default {
        components: {OrderDetail},
        data() {
            return {
                drawer:false,
                datas:{}
            }
        },
        methods: {
            open(val) {
                this.datas = val
                console.log(val,'kdsakdkask')
                this.drawer = true
            }
        }
    }
</script>

<style scoped lang="scss">
::v-deep .Order-Detail-Drawer .el-drawer__header {
    display: none;
}
</style>